// extracted by mini-css-extract-plugin
export var infoItem = "_qq-2";
export var title = "_qq-0";
export var value = "_qq-1";